<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Regimen fiscal</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Fac_4.0</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Busqueda de regimen fiscal
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>
              <b-form-group align="left">
                <label for="nombreBusq">Busqueda por clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                      name="nombre"
                      type="number"
                      placeholder="Clave"
                      v-model="regimenFiscalFiltro.clave"
                      @keydown.enter.native="obtener"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col></b-col>

            <b-col align="right">
              <b-button
                  v-b-tooltip.hover
                  title="Agregar régimen fiscal"
                  variant="outline-success"
                  @click="agregar"
                  v-if="$localStorageService.can('Fac_4.0_crear')"
              >
                Agregar régimen fiscal
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-table
              id="Regimen"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="porPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
          >
            <template v-slot:cell(idTipoPersona)="row">
              <span v-if="row.item.idTipoPersona === 1">
                MORAL
              </span>
              <span v-else>
                FISICA
              </span>
            </template>

            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    title="Modificar régimen"
                    size="sm"
                    @click="modificar(row.item)"
                    variant="outline-warning"
                    v-if="$localStorageService.can('Fac_4.0_editar')"
                >
                  <em class="fa fa-pencil"></em>
                </b-button>
                <b-button
                    v-if="!row.item.registroActivo && $localStorageService.can('Fac_4.0_activar')"
                    title="Activar régimen"
                    size="sm"
                    @click="activar(row.item)"
                    variant="outline-danger"
                >
                  <em class="fa fa-undo"></em>
                </b-button>
                <b-button
                    v-else-if="$localStorageService.can('Fac_4.0_activar')"
                    title="Desactivar régimen"
                    size="sm"
                    @click="desactivar(row.item)"
                    variant="outline-danger"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>
            </template>
          </b-table>

          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="porPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
    </b-container>

    <b-modal
        v-model="mostrarModal"
        :title="tituloModal"
        size="lg"
        scrollable
    >
      <b-form @submit.stop.prevent="guardar">
        <b-container fluid>
          <b-row>
            <b-col>
              <b-form-group align="left">

                <label for="nombre">Nombre <validacion/> </label>
                <b-input-group size="sm" class="mb-2" id="nombre">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                      name="nombre"
                      placeholder="Nombre del régimen fiscal"
                      v-model="regimenFiscal.nombre"
                      :state="regimenFiscal.nombre != '' && regimenFiscal.nombre != null"
                      required
                  >
                  </b-form-input>
                </b-input-group>

                <b-row>
                  <b-col>
                    <label for="nombre">Clave <validacion/> </label>
                    <b-input-group size="sm" class="mb-2" id="calve">
                      <b-input-group-prepend is-text>
                        <b-icon icon="menu-button-wide"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input
                          name="clave"
                          placeholder="Clave"
                          v-model="regimenFiscal.clave"
                          :state="regimenFiscal.clave != '' && regimenFiscal.clave != null"
                          required
                      >
                      </b-form-input>
                    </b-input-group>
                  </b-col>

                  <b-col>
                    <label for="nombre">Tipo persona <validacion/> </label>
                    <b-input-group size="sm" class="mb-2" id="persona">
                      <b-input-group-prepend is-text>
                        <b-icon icon="menu-button-wide"></b-icon>
                      </b-input-group-prepend>
                      <b-form-select
                          name="persona"
                          placeholder="Tipo persona"
                          v-model="regimenFiscal.idTipoPersona"
                          :options="opTipoPersona"
                          :state="regimenFiscal.idTipoPersona != '' && regimenFiscal.idTipoPersona != null"
                          required
                      >
                      </b-form-select>
                    </b-input-group>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>
        <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
      </b-form>

      <template v-slot:modal-footer>
        <b-button variant="outline-primary" type="submit" @click="submitGuardar" :disabled="loaderAcciones">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal">Cancelar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "RegimenFiscal",
  components: {Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      regimenFiscalFiltro: {
        clave: null
      },
      regimenFiscal: {
        idRegimenFiscal: null,
        nombre: null,
        clave: null,
        idTipoPersona: null,
        registroActivo: null
      },
      opTipoPersona: [
        { value: null, text: 'Selecciona tipo persona' },
        { value: 1, text: 'MORAL' },
        { value: 2, text: 'FISICA' }
      ],
      datosTabla: [],
      fields: [
        { key: "idRegimenFiscal", label: "ID", sortable: true },
        { key: "clave", label: "Clave", sortable: true },
        { key: "nombre", label: "Nombre", sortable: true },
        { key: "idTipoPersona", label: "Tipo persona", sortable: true},
        "Acciones"
      ],
      loader: false,
      loaderAcciones: false,
      paginaActual: 1,
      porPagina: 10,
      mostrarModal: false,
      tituloModal: null,
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtener();
  },
  methods: {
    obtener() {
      this.loader = true;
      this.datosTabla = [];
      this.regimenFiscalFiltro.clave = parseInt(this.regimenFiscalFiltro.clave);
      this.$http.post(this.$api + 'catalogos/regimenFiscal/obtenerRegimenFiscal', this.regimenFiscalFiltro).then(respuesta => {
        if(respuesta.data.data){
          this.datosTabla = respuesta.data.data;
        }
      }).finally(() => {
        this.loader = false;
      })
    },
    agregar() {
      this.regimenFiscal = {
        idRegimenFiscal: null,
        nombre: null,
        clave: null,
        idTipoPersona: null
      };
      this.tituloModal = 'Agregar régimen';
      this.mostrarModal = true;
    },
    guardar() {
      this.loaderAcciones = true;
      this.$http.post(this.$api + 'catalogos/regimenFiscal/guardarRegimenFiscal', this.regimenFiscal).then(respuesta => {
        if(respuesta.data.success) {
          this.$swal.fire({
            icon: "info",
            title: "Aviso",
            text: respuesta.data.message
          });
          if (respuesta.data.data != null){
            this.regimenFiscalFiltro.clave = this.regimenFiscal.clave;
            this.obtener();
            this.mostrarModal = false;
          }
        }
      }).catch(error => {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Hubo un problema al guardar."
        });
      }).finally(() => {
        this.loaderAcciones = false;
      })
    },
    modificar(item) {
      this.regimenFiscal = JSON.parse(JSON.stringify(item));
      this.tituloModal = 'Modificar régimen fiscal';
      this.mostrarModal = true;
    },
    activar(item) {
      this.$swal({
        icon: "warning",
        text: "¿Está seguro de activar el rérgimen fiscal?",
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idRegimenFiscal: item.idRegimenFiscal,
          };

          this.$http.post(this.$api + 'catalogos/regimenFiscal/desactivarRegimenFiscal', parametros ).then(respuesta => {
            if (respuesta.data.data) {
              this.datosTabla[this.datosTabla.indexOf(item)].registroActivo = true;
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "El regimen fiscal se activó correctamente."
              });
            }
          }).catch(error => {
            console.error(error);
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Hubo un problema al activar.",
            });
          })
        }
      })
    },
    desactivar(item) {
      this.$swal({
        icon: "warning",
        text: "¿Está seguro de desactivar el régimen fiscal?",
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {

          const parametros = {
            idRegimenFiscal: item.idRegimenFiscal,
          };

          this.$http.delete(this.$api + 'catalogos/regimenFiscal/activarRegimenFiscal', parametros ).then(respuesta => {
            if (respuesta.data.data) {
              this.datosTabla[this.datosTabla.indexOf(item)].registroActivo = false;
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "El régimen fiscal se desactivó correctamente."
              });
            }
          }).catch(error => {
            console.error(error);
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Hubo un problema al desactivar.",
            });
          })
        }
      })
    },
    submitGuardar() {
      this.$refs.submitGuardar.click();
    },
    cerrarModal() {
      this.mostrarModal = false;
      this.regimenFiscal = {
        idRegimenFiscal: null,
        nombre: null,
        clave: null,
        idTipoPersona: null
      };
    }
  }
}
</script>

<style scoped>

</style>